export default {
	get(): boolean {
		return true;
	},
};
